import { appContextProvider } from './app-context.provider.js';
export { configureAppContextProvider } from './app-context.provider.js';
import { appContextStore } from './app-context.state.js';
export { useAppContext } from './app-context.state.js';
export { configureIframeExport } from './util.configure-iframe-export.js';
export { stringifyPublisher } from './util.stringify-publisher.js';

const appContext = Object.freeze({
  ...appContextStore,
  async getPageAuthors() {
    const { product, page, course } = appContextStore.getState();
    const descriptor = course ?? page;
    if (!product || !descriptor) {
      return;
    }
    return appContextProvider.getPageAuthors(product, descriptor);
  }
});

export { appContext };
//# sourceMappingURL=index.js.map
